  <div class="hw-box-content">
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-6">
                <i class="fn-global-site"></i>
                Day Analysis
            </div>
        </div>
    </div>
    <div class="hw-title">
        <div class="row">
          <div class="col-12">
             <ul class="list-inline">
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="customDate">Custom Date</label>
                </div>
              </li>
              <li class="align-top pt-7">
                <fn-switch [(ngModel)]="customDate" [name]="'customDate'"></fn-switch>
              </li>
              @if(!customDate){
              <li class="align-top width-210px">
                <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
                  [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
                </fn-date-range-picker>
              </li> 
            }@if(customDate){
              <li class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="dayArray"
                  [placeholder]="'selected Day'" [(ngModel)]="selectedDay" [ngModelOptions]="{standalone: true}">
                </fn-select>
              </li>
            }
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="inlineFormCheck">
                    Select Product
                  </label>
                </div>
              </li>
              <li class="align-top width-200px">
                <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray"
                  [placeholder]="'Select Product'" [(ngModel)]="selectProduct" [ngModelOptions]="{standalone: true}" (changeEvent)="getIdenNoData(selectProduct)">
                </fn-select>
              </li>
                <li class="align-top pt">
                  <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                    (click)="getProductStats()"></fn-button>
                </li>
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="inlineFormCheck">
                    Select IdenNo
                  </label>
                </div>
              </li>
              <li class="align-top width-200px">
                <fn-select [labelKey]="'idenNo'" [inputKey]="'primaryKey'" [optionList]="idenNoArray"
              [placeholder]="'Select idenNo'" [(ngModel)]="selectIdenNo" [ngModelOptions]="{standalone: true}">
            </fn-select>
              </li>
              <li class="align-top pt">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                  (click)="getHistData(selectIdenNo)"></fn-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
  <div class="hw-content">
    <div class="row">
      <div class="col-12">  
        <div class="no_data_display" [hidden]="chartData.length > 0">
          No Data To Display
        </div>
        <div id="chartdiv" style="width: 100%; height: calc(100vh - 270px)" [hidden]="chartData.length === 0"></div>
      </div>
    </div>
  </div>
  </div>
